import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';

var AppSearchBtn = /*#__PURE__*/function (_Vue) {
  _inherits(AppSearchBtn, _Vue);

  var _super = _createSuper(AppSearchBtn);

  function AppSearchBtn() {
    _classCallCheck(this, AppSearchBtn);

    return _super.apply(this, arguments);
  }

  _createClass(AppSearchBtn, [{
    key: "submit",
    value: function submit() {}
  }]);

  return AppSearchBtn;
}(Vue);

__decorate([Emit('submit')], AppSearchBtn.prototype, "submit", null);

AppSearchBtn = __decorate([Component({})], AppSearchBtn);
export default AppSearchBtn;